import {ConfigurationProfile} from "@/components/device/configuration/types";


export const nsenDeviceConfigurationProfile:ConfigurationProfile = {
  '0xc9': {
    id: 0xc9,
    stringId: 'report1Period',
    label: 'report 1',
    type: 'number',
    unit: 'seconds',
    min: 60,
    max: 86400,
    position: 1,
    sectionId: '0xc9',
    newUiSection: true,
  },
  '0xca': {
    id: 0xca,
    stringId: 'report1Mask',
    label: 'report 1 mask',
    type: 'checkbox-group',
    options: [{
      value: 'svpb',
      label: 'Primary Battery Voltage',
    }, {
      value: 'sipb',
      label: 'Primary Battery Current'
    }, {
      value: 'svext',
      label: 'External Voltage'
    }, {
      value: 'pulse1',
      label: 'Pulse Input Count 1'
    }, {
      value: 'pulse2',
      label: 'Pulse Input Count 2'
    }, {
      value: 'pulse3',
      label: 'Pulse Input Count 3'
    }, {
      value: 'relativeHumidityPercent',
      label: 'Relative Humidity Percent'
    }, {
      value: 'temperature',
      label: 'Temperature'
    }, {
      value: 'cpuAveUsage',
      label: 'CPU Usage',
    }, {
      value: 'cpuUpTime',
      label: 'CPU Uptime',
    }, {
      value: 'RSSIDown',
      label: 'RSSI Down',
    }, {
      value: 'SNRDown',
      label: 'SNR Down',
    }, {
      value: 'pulse1State',
      label: 'Pulse 1 State',
    }, {
      value: 'pulse2State',
      label: 'Pulse 2 State',
    }, {
      value: 'pulse3State',
      label: 'Pulse 3 State',
    }, {
      value: 'pulse1Accum',
      label: 'Pulse 1 Accumulate',
    }, {
      value: 'pulse2Accum',
      label: 'Pulse 2 Accumulate',
    }, {
      value: 'pulse3Accum',
      label: 'Pulse 3 Accumulate',
    }],
    position: 2,
    sectionId: '0xc9',
  },
  '0xcd': {
    id: 0xcd,
    stringId: 'report2Period',
    label: 'report 2',
    type: 'number',
    unit: 'seconds',
    min: 60,
    max: 86400,
    position: 2,
    sectionId: '0xcd',
    newUiSection: true,
  },
  '0x74': {
    id: 0x74,
    stringId: 'paBoost',
    label: 'RF Power Boost',
    type: 'toggle',
    options: [{ label: 'On', value: '1' }, { label: 'Off', value: '0' }],
    position: 3,
    sectionId: '0x74',
    newUiSection: true,
    command: 'p1'
  },
  '0xce': {
    id: 0xce,
    stringId: 'report2Mask',
    label: 'report 2 mask',
    type: 'checkbox-group',
    options: [{
      value: 'svpb',
      label: 'Primary Battery Voltage',
    }, {
      value: 'sipb',
      label: 'Primary Battery Current'
    }, {
      value: 'svext',
      label: 'External Voltage'
    }, {
      value: 'pulse1',
      label: 'Pulse Input Count 1'
    }, {
      value: 'pulse2',
      label: 'Pulse Input Count 2'
    }, {
      value: 'pulse3',
      label: 'Pulse Input Count 3'
    }, {
      value: 'relativeHumidityPercent',
      label: 'Relative Humidity Percent'
    }, {
      value: 'temperature',
      label: 'Temperature'
    }, {
      value: 'cpuAveUsage',
      label: 'CPU Usage',
    }, {
      value: 'cpuUpTime',
      label: 'CPU Uptime',
    }, {
      value: 'RSSIDown',
      label: 'RSSI Down',
    }, {
      value: 'SNRDown',
      label: 'SNR Down',
    }, {
      value: 'pulse1State',
      label: 'Pulse 1 State',
    }, {
      value: 'pulse2State',
      label: 'Pulse 2 State',
    }, {
      value: 'pulse3State',
      label: 'Pulse 3 State',
    }, {
      value: 'pulse1Accum',
      label: 'Pulse 1 Accumulate',
    }, {
      value: 'pulse2Accum',
      label: 'Pulse 2 Accumulate',
    }, {
      value: 'pulse3Accum',
      label: 'Pulse 3 Accumulate',
    }],
    position: 2,
    sectionId: '0xcd',
  },
  '0x97': {
    id: 0x97,
    stringId: 'autoOnOff',
    label: 'Auto On/Off',
    type: 'toggle',
    options: [{ label: 'Enable', value: '1' }, { label: 'Disable', value: '0' }],
    position: 4,
    sectionId: '0x97',
    newUiSection: true,
    command: 'p1'
  },
};
